import { minutesToString } from 'util/menuUtils';

const onDays = (days) => (days && days.length > 0 ? ` on ${days.join(', ')}` : '');

/** The visibility rules set on a category or dish, as short sentences (the classic editor's chips). */
export const visibilityNotes = (entry) => {
  if (!entry) {
    return [];
  }
  const notes = [];
  if (entry.active === false) {
    notes.push(`Hidden from menu${onDays(entry.hideDays)}`);
  }
  if (entry.hidden_until != null) {
    notes.push(`Hidden until ${new Date(entry.hidden_until).toLocaleString()}`);
  }
  if (entry.active_begin != null && entry.active_end) {
    notes.push(
      `Shown only ${minutesToString(entry.active_begin)} – ${minutesToString(entry.active_end)}${onDays(
        entry.activeWeekDays || entry.active_days
      )}`
    );
  }
  if (entry.hidden_begin != null && entry.hidden_end != null) {
    notes.push(
      `Hidden ${minutesToString(entry.hidden_begin)} – ${minutesToString(entry.hidden_end)}${onDays(entry.hiddenWeekDays)}`
    );
  }
  return notes;
};

/** One line for the category rail's hidden icon, or null when the category is plainly visible. */
export const categoryHiddenNote = (category) => {
  const notes = visibilityNotes(category);
  if (category.hideForWeb === true) {
    notes.unshift('Hidden from web');
  }
  return notes.length > 0 ? notes.join(' · ') : null;
};
